// extracted by mini-css-extract-plugin
export default {"telegram":"telegram_telegram__1Pt4C"};